
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FAQHeroSection from './components/FAQHeroSection';
import FAQSections from './components/FAQSections';
import StillHaveQuestionsSection from './components/StillHaveQuestionsSection';

const FAQPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <FAQHeroSection />
        <FAQSections />
        <StillHaveQuestionsSection />
      </main>
      <Footer />
    </div>
  );
};

export default FAQPage;
